export default {
    getHeaderFieldsEprofileAktGyogy: state => state.headerFieldsEprofileAktGyogy,
    getFormActionsEprofileAktGyogy: state => state.formActionsEprofileAktGyogy,
    getActionsEprofileAktGyogy: state => state.actionsEprofileAktGyogy,
    getRowActionsEprofileAktGyogy: state => state.rowActionsEprofileAktGyogy,
    getSearchFields: state => state.searchFields,
    isFormOpenEprofileAktGyogy: state => state.formIsOpen,
    isGridOpenEprofileAktGyogy: state => state.gridIsOpen
}
